// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TZn2ZgUUjA8UJC {
  max-width: calc(280px * 2 + 12px);
  margin: var(--ds-space-0, 0) auto;
  text-align: center;
}
.qRxvhEwv8zfkFj {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.xB_uYGUVFZ7Kjq {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 12px;
}
.xB_uYGUVFZ7Kjq > * {
  flex: 0 1 280px;
}
@media (max-width: 750px) {
  .xB_uYGUVFZ7Kjq {
    flex-direction: column-reverse;
    align-items: center;
    margin-top: var(--ds-space-300, 24px);
  }
  .xB_uYGUVFZ7Kjq > * {
    width: 100%;
    max-width: 280px;
  }
}
.ZSsjSBOHcTj7CL {
  margin: var(--ds-space-0, 0) auto;
  margin-top: var(--ds-space-200, 16px);
  text-align: center;
}
.zz4MJDc60Wb23y {
  width: 80%;
  margin: var(--ds-space-0, 0) auto;
  text-align: center;
}
.gopwWDHVddO3qk {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.PFiS2MdpQu_zOs {
  margin-right: 3px;
  color: var(--ds-text, #091e42);
  font-size: 29px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 30px;
}
.JvFAxaIrZPy34s {
  color: token('color.text.subtle', '#44546F');
  font-size: 12px;
  font-style: normal;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}
._ESFK53KWcMqiH {
  padding-bottom: 1px;
  border-bottom: 1px dashed var(--ds-background-accent-gray-subtle, #8590a2);
  cursor: pointer;
}
.zCXDI0AE9l87QC {
  font-size: 12px;
  font-weight: var(--ds-font-weight-bold, bold);
}
.l20p0AZc0632XC {
  margin-left: var(--ds-space-100, 8px);
}
.rbnLbaGAS9yZ0K {
  border: 3px solid var(--ds-border-discovery, #8270db);
  border-radius: 8px;
  background: var(--ds-background-discovery, #f3f0ff);
}
.rbnLbaGAS9yZ0K legend {
  margin: auto;
  /* to center */
  padding: var(--ds-space-100, 8px) 15px;
  border-radius: 4px;
  background: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  font-style: normal;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 16px;
}
.vpimM6lUEZJGO6 {
  margin-top: var(--ds-space-150, 12px);
  border: 3px solid var(--ds-border, #091e4224);
  border-radius: 8px;
}
.oRJuaI4jjDhx0b {
  flex: 1;
  padding: var(--ds-space-0, 0) 36px 14px;
}
.oRJuaI4jjDhx0b li {
  margin-top: var(--ds-space-150, 12px);
  font-size: 14px;
}
.I7Ad5trnt1h6XR {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  margin-bottom: 15px;
  padding: var(--ds-space-0, 0);
  border: 0;
}
.o1tdqhbgVWVxZG {
  max-width: calc(280px * 2 + 12px);
  margin: var(--ds-space-0, 0) auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeader": `TZn2ZgUUjA8UJC`,
	"featureSelectionContainer": `qRxvhEwv8zfkFj`,
	"plansContainer": `xB_uYGUVFZ7Kjq`,
	"stadardHeader": `ZSsjSBOHcTj7CL`,
	"premiumHeader": `zz4MJDc60Wb23y`,
	"pricingSection": `gopwWDHVddO3qk`,
	"pricingLable": `PFiS2MdpQu_zOs`,
	"billingPeriodLable": `JvFAxaIrZPy34s`,
	"tooltipTarget": `_ESFK53KWcMqiH`,
	"featureListTitle": `zCXDI0AE9l87QC`,
	"featureSpan": `l20p0AZc0632XC`,
	"premiumPlanFieldSet": `rbnLbaGAS9yZ0K`,
	"standardPlanFieldSet": `vpimM6lUEZJGO6`,
	"featureList": `oRJuaI4jjDhx0b`,
	"fieldSet": `I7Ad5trnt1h6XR`,
	"warning": `o1tdqhbgVWVxZG`
};
export default ___CSS_LOADER_EXPORT___;
